import { render, staticRenderFns } from "./m_AllTranslationSkills.vue?vue&type=template&id=384f5d9e&scoped=true&"
import script from "./m_AllTranslationSkills.vue?vue&type=script&lang=js&"
export * from "./m_AllTranslationSkills.vue?vue&type=script&lang=js&"
import style0 from "./m_AllTranslationSkills.vue?vue&type=style&index=0&id=384f5d9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384f5d9e",
  null
  
)

export default component.exports